import { analytics } from './analytics'
import { McpEvents } from './events'

export type McpClientKind = 'token' | 'oauth'

export type McpWizardSource = 'header' | 'empty_state' | 'trigger'

export type McpConsentDecision = 'approved' | 'denied'

export function trackMcpWizardOpened(properties: {
  source: McpWizardSource
}): void {
  analytics.track(McpEvents.WIZARD_OPENED, properties)
}

export function trackMcpClientPicked(properties: {
  client: string
  kind: McpClientKind
}): void {
  analytics.track(McpEvents.CLIENT_PICKED, properties)
}

export function trackMcpTokenCreated(properties: { client: string }): void {
  analytics.track(McpEvents.TOKEN_CREATED, properties)
}

export function trackMcpConnectorUrlCopied(properties: {
  client: string
}): void {
  analytics.track(McpEvents.CONNECTOR_URL_COPIED, properties)
}

export function trackMcpConsentDecided(properties: {
  client_name: string | null
  decision: McpConsentDecision
}): void {
  const event =
    properties.decision === 'approved'
      ? McpEvents.CONSENT_APPROVED
      : McpEvents.CONSENT_DENIED
  analytics.track(event, { client_name: properties.client_name })
}
